export default [
  {
    label: 'Character',
    value: 'character',
  },
  {
    label: 'Genre Category',
    value: 'genre-category',
  },
  {
    label: 'Genre Form',
    value: 'genre-form',
  },
  {
    label: 'Grammar',
    value: 'grammar',
  },
  {
    label: 'Linguistics',
    value: 'linguistics',
  },
  {
    label: 'Narrative',
    value: 'narrative',
  },
  {
    label: 'Plot',
    value: 'plot',
  },
  {
    label: 'Poetry',
    value: 'poetry',
  },
  {
    label: 'Rhetoric: Figurative',
    value: 'rhetoric-figurative',
  },
  {
    label: 'Rhetoric: Persuasive',
    value: 'rhetoric-persuasive',
  },
  {
    label: 'Story Structure & Literary Technique',
    value: 'story-structure-literary-technique',
  },
  {
    label: 'Style',
    value: 'style',
  },
]
